<template>
  <div class="orgMain">
    <div class="searchWrap">
      <div class="selectWrap">
        <select id="province"
                v-model="search.province_id"
                @change="updateCity">
          <option value="">全部省份</option>
          <option v-for="(item, index) in search.area"
                  :key="index"
                  :value="item.id">{{ item.regionName }}
          </option>
        </select>
        <select id="city"
                v-model="search.city_id"
                @change="getRequest">
          <option value="">全部城市</option>
          <option v-for="(item, index) in search.city"
                  :key="index"
                  :value="item.id">{{ item.regionName }}
          </option>
        </select>
      </div>
      <div class="search">
        <div class="wrap">
          <input type="text"
                 placeholder="请输入搜索内容"
                 v-model.lazy="search.name"
                 @keyup.enter="getRequest">
          <div v-show="search.name!=''"
               class="close"
               @click="hideIcon">
            <v-icon name="regular/times-circle"
                    scale="1.2"></v-icon>
          </div>
        </div>
        <div class="searchBtn"
             @click="getRequest">搜索
        </div>
      </div>
    </div>
    <yioks-loading v-show="isLoading"></yioks-loading>
    <template v-if="!isLoading">
      <template v-if="showList">
        <div class="table">
          <div class="thead">
            <div class="tr">
              <div class="th index"><strong>序号</strong></div>
              <div class="th org"><strong>培训机构名称</strong></div>
              <div class="th name"><strong>管理员姓名</strong></div>
              <div class="th province"><strong>省份</strong></div>
              <div class="th city"><strong>城市</strong></div>
              <div class="th status"><strong>状态</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll :ops="ops" ref="vs">
              <div class="tbodyWrap">
                <div class="tbody">
                  <div class="tr"
                       v-for="(item, index) in list"
                       :key="index">
                    <div class="td index">
                      <p>{{ index+1 }}</p>
                    </div>
                    <div class="td org">
                      <p>{{ item.name }}</p>
                    </div>
                    <div class="td name">
                      <p>{{ item.user_name }}</p>
                    </div>
                    <div class="td province">
                      <p>{{ item.provice_name }}</p>
                    </div>
                    <div class="td city">
                      <p>{{ item.city_name || "--" }}</p>
                    </div>
                    <div class="td status">
                      <p>{{ item.status | orgStatus }}</p>
                    </div>
                    <div class="td opt">
                      <span @click="lookOver(item.org_id)">查看</span>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <div id="paging">
          <yioks-paging :paging="paging"
                        @goto-page="gotoPage($event)"></yioks-paging>
        </div>
      </template>
      <yioks-empty v-show="showEmpty"></yioks-empty>
    </template>
  </div>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import {organization} from "@/api/system_manager/api";
  import {area_list} from "@/assets/js/region";
  export default {
    name: "eva-organization",
    data() {
      return {
        isLoading: true,
        showList: false,
        showEmpty: false,
        ops: ops(),
        list: [],
        page: 1,
        paging: {
          start: 0, // 每页从第几条数据开始
          prePage: 1, // 一页多少条数据
          total: 0, // 总页数
          size: 3, // 页码显示限制
          last: true, // 尾页
          next: true, // 下一页
          first: true, // 首页
          previous: true, // 上一页
          jump: true
        },
        search: {
          area: area_list,
          city: [],
          province_id: "",
          city_id: "",
          name: ""
        }
      }
    },
    components: {
      "yioks-paging": () => import("@/components/Pagination/Page"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "v-icon": () => import("vue-awesome/components/Icon")
    },
    created() {
      this.setData();
      this.request();
    },
    filters: {
      orgStatus(status) {
        switch (status) {
          case "Active":
            status = "正常";
            break;
          case "Abnormal":
            status = "暂停";
            break;
          /*case "Stop": status = "关闭"; break;
          case "Deleted": status = "删除"; break;*/
          default:
            status = "--";
            break;
        }
        return status;
      }
    },
    methods: {
      setData() {
        // console.log(this.$route.query);
        const {pid, cid, name, page} = this.$route.query;
        pid && (this.$set(this.search, "province_id", pid));
        pid && (this.getCityList());
        cid && (this.$set(this.search, "city_id", cid));
        name && (this.$set(this.search, "name", name));
        page && (this.page = page);
      },
      request() {
        this.isLoading = true;
        organization({
          "province_id": this.search.province_id,
          "city_id": this.search.city_id,
          "name": this.search.name,
          "page": this.page
        })
          .then(res => {
            this.isLoading = false;
            // console.log(res);
            const {result} = res.data;
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
            this.list = res.data.result.list;
            this.showList = Boolean(this.list.length > 0);
            this.showEmpty = !this.showList;
          })
          .catch(err => {
            this.isLoading = false;
            console.error(err);
          });
      },
      hideIcon() {
        this.$set(this.search, "name", "");
        this.getRequest();
      },
      changeQuery(flag) {
        flag && (this.page = 1);
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            pid: this.search.province_id,
            cid: this.search.city_id,
            name: this.search.name,
            page: this.page,
          }
        });
        this.request();
      },
      getRequest() {
        this.changeQuery(true);
      },
      updateCity() {
        this.$set(this.search, "city_id", "");
        this.getRequest();
        this.getCityList();
      },
      getCityList() {
        const city = this.$yioks.updateCity(this.search.province_id, this.search.area);
        this.$set(this.search, "city", city);
      },
      gotoPage(start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
        this.$refs['vs'].scrollTo({ y: 0 });
      },
      lookOver(id) {
        this.$router.push({path: '../eva_org_detail', query: {id: id}});
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .orgMain {
    width: 100%;
    height: 100%;
    padding: 25px 0 0;
    .searchWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      margin: 0 40px;
      .selectWrap {
        width: 335px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        select {
          width: 155px;
          height: 100%;
          padding: 0 15px;
          font-size: $font_size_medium;
          color: $color_black;
          outline: none;
        }
      }
      .search {
        width: 390px;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .wrap {
          height: 100%;
          position: relative;
          input {
            width: 290px;
            height: 100%;
            padding: 0 20px;
            font-size: $font_size_medium;
            color: $color_black;
            outline: none;
          }
          .close {
            position: absolute;
            right: 5px;
            top: 10px;
            color: $color_info;
            cursor: pointer;
          }
        }
        .searchBtn {
          width: 90px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          background-color: $color_suc;
          cursor: pointer;
          user-select: none;
        }
      }
    }
    .table {
      width: 100%;
      margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 401px;
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          over_hide();
        }
      }
      .td:last-child {
        color: $color_suc;
        user-select: none;
      }
      .index {
        width: 6%;
      }
      .province {
        width: 14%;
      }
      .city {
        width: 15%;
      }
      .org {
        width: 25%;
      }
      .name {
        width: 19%;
      }
      .status {
        width: 9%;
      }
      .opt {
        width: 11%;
        span {
          cursor: pointer;
        }
      }
    }
    #paging {
      width: 100%;
      height: 77px;
    }
  }

</style>
